<div class="row text-center animate__animated animate__fadeIn">
    <div class="col">
        <i class="far fa-compass fa-spin fa-4x" style="color:#73253f"></i>
    </div>
</div>